"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const coam_repository_1 = require("./coam-repository");
const nested_error_1 = require("./helpers/nested-error");
async function getAllowedIds(resourceType, principal, permission, authorization, correlationId) {
    const resourceTypePermissions = await coam_repository_1.getResourceTypePermissions(resourceType, principal, authorization, correlationId);
    const allowed = [];
    resourceTypePermissions.forEach(resourcePermission => {
        if (resourcePermission.permissions.includes(permission)) {
            allowed.push(resourcePermission.identifier);
        }
    });
    if (allowed.includes('*')) {
        return 'all';
    }
    return allowed;
}
exports.getAllowedIds = getAllowedIds;
async function isAllowed(resourceIdentifier, resourceType, principal, permission, authorization, correlationId) {
    const resourcePermissions = await coam_repository_1.getResourcePermissions(resourceIdentifier, resourceType, principal, authorization, correlationId);
    return (resourcePermissions && resourcePermissions.permissions.includes(permission));
}
exports.isAllowed = isAllowed;
async function authenticateCoamClient(client) {
    try {
        const response = (await axios_1.default.request({
            method: 'POST',
            url: 'https://oauth.cimpress.io/v2/token',
            data: {
                audience: 'https://api.cimpress.io/',
                client_id: client.id,
                client_secret: client.secret,
                grant_type: 'client_credentials',
            },
        })).data;
        if (!response.access_token) {
            return Promise.reject(new Error('response does not contain access token'));
        }
        return response.access_token;
    }
    catch (err) {
        throw nested_error_1.nestError('COAM client authentication failed', err.error);
    }
}
exports.authenticateCoamClient = authenticateCoamClient;
async function getResourcePermissions(resourceIdentifier, resourceType, principal, authorization, correlationId) {
    return coam_repository_1.getResourcePermissions(resourceIdentifier, resourceType, principal, authorization, correlationId);
}
exports.getResourcePermissions = getResourcePermissions;
//# sourceMappingURL=coam-auth.js.map